import axios from 'axios';

const API_URL = 'https://wluoiqik1i.execute-api.us-east-1.amazonaws.com/prod';

export const submitContactForm = async formData => {
  try {
    const response = await axios.post(`${API_URL}/forms/contact`, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

export const subscribeToNewsletter = async email => {
  try {
    const response = await axios.post(`${API_URL}/forms/newsletter`, { email });
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};
